import { PublicClientApplication, type Configuration } from '@azure/msal-browser';

const clientId = import.meta.env.VITE_CLIENT_ID ?? '';
const tenantId = import.meta.env.VITE_TENANT_ID ?? '';

/** VITE_CLIENT_ID 미설정 시 MSAL 미사용(개발 모킹) 모드 */
export const authConfigured = Boolean(clientId && tenantId);

const configuration: Configuration = {
  auth: {
    clientId,
    authority: `https://login.microsoftonline.com/${tenantId}`,
    redirectUri: import.meta.env.VITE_REDIRECT_URI ?? window.location.origin,
  },
  cache: {
    cacheLocation: 'sessionStorage',
  },
};

export const msalInstance = new PublicClientApplication(configuration);

/**
 * 로그인/토큰 요청 스코프. User.Read(위임)는 관리자 동의 완료되어 무중단 silent 획득 가능.
 * 백엔드 호출에는 이 요청 결과의 idToken(aud=client-id)을 Bearer 로 전달한다
 * (별도 "Expose an API" 구성 없이 검증 가능).
 */
export const loginScopes: string[] = ['User.Read', 'openid', 'profile', 'offline_access'];
